import Cookies from 'js-cookie';

const LOGGED_IN_USER_KEY = 'fs3_logged_in_user';

export function urlParam(name: string): any {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
        return 0;
    }
    return results[1] || 0;
}

export function isAuthenticated(): boolean {
    return !!Cookies.get('fs3_access_token');
}

export function isAuthenticatedToExploreApp(): boolean {
    const workspaceCount = Cookies.get('fs3_workspace_count');
    return workspaceCount ? parseInt(workspaceCount) > 0 : false;
}

export function setAccessToken(name: string, value: string) {
    Cookies.set(name, value, { expires: 1000 }); // Store for 1000 days
}

export function setWorkspaceCount(name: string, value: string) {
    Cookies.set(name, value, { expires: 1000 }); // Store for 1000 days
}

export function updateWorkspaceCount() {
    const currentWorkspaces = Cookies.get("fs3_workspace_count") || "0"; 
    const updatedWorkspaces = parseInt(currentWorkspaces) + 1;
    Cookies.set("fs3_workspace_count", updatedWorkspaces.toString(), { expires: 1000 }); // Store for 1000 days
}

export function getAccessToken(name: string): string | undefined {
    return Cookies.get(name);
}

export function getWsId(name: string): string | undefined {
    const LOGGED_IN_USER = Cookies.get(LOGGED_IN_USER_KEY);
    return Cookies.get(name + (LOGGED_IN_USER ? '_' + LOGGED_IN_USER : ''));
}

export function clearAccessToken(name: string) {
    Cookies.remove(name);
}

export function disableButton(button: HTMLButtonElement | HTMLElement, displayLoader: boolean = true) {
    if (displayLoader) {
        button.classList.add('relative');

        const label = button.querySelector('span.btn-label');
        if (label) {
            label?.classList.add('opacity-0');
        }

        // Only add loader if not already present
        const existingLoader = button.querySelector('.btn-loader-icon');
        if (!existingLoader) {
            // Add loader icon inside the button
            const loader = document.createElement('div');
            loader.classList.add('btn-loader-icon', 'absolute', 'left-[50%]', 'top-[50%]', 'ml-[-8px]', 'mt-[-8px]', 'animate-spin', 'size-4', 'border-[3px]', 'border-current', 'border-t-transparent', 'rounded-full');
            loader.setAttribute('role', 'status');
            
            // Check if the button has the 'bg-white' class
            if (button.classList.contains('bg-white')) {
                loader.classList.add('text-black'); // Loader with black border for white background
            } else {
                loader.classList.add('text-white'); // Default loader
            }
            
            button.appendChild(loader);
        }
    }

    // Disable the button
    (button as HTMLButtonElement).disabled = true;
    button.classList.add('opacity-50', 'pointer-events-none');
}

export function enableButton(button: HTMLButtonElement | HTMLElement, hideLoader: boolean = true) {
    // Re-enable the button
    (button as HTMLButtonElement).disabled = false;
    button.classList.remove('opacity-50', 'pointer-events-none');
    
    if (hideLoader) {
        button.classList.remove('relative');

        const label = button.querySelector('span.btn-label');
        const loader = button.querySelector('.btn-loader-icon');

        if (label) {
            label?.classList.remove('opacity-0');
        }

        if (loader) {
            loader.remove();
        }
    }
}

export function getInitialBackground() {
    const colorClasses = [
        'bg-blue-100 text-blue-900 dark:bg-blue-800/60 dark:text-blue-50',
    ];
    const randomIndex = Math.floor(Math.random() * colorClasses.length);
    return colorClasses[randomIndex];
}

export function getInitial(name: string): string {
    const nameParts = name.split(' ');
    const firstInitial = nameParts[0].charAt(0);
    const secondInitial = nameParts.length > 1 ? nameParts[1].charAt(0) : '';
    return (firstInitial + secondInitial).toUpperCase();
}

export const openCrispChat = () => {
    $crisp.push(['do', 'chat:open']);
};

export function toggleElement(toggleSwitch: boolean, element: HTMLElement): void {
    if (toggleSwitch) {
        element?.classList.remove("hidden");
    } else {
        element?.classList.add("hidden");
    }
}

export function simplifyUrl(url = ''): string {
    return url.replace(/^https?:\/\/[a-zA-Z0-9-]+\.feedspace\.io/, 'feedspace.io');
}

export function isValidHexColor(color: string): boolean {
    const hexColorRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
    return hexColorRegex.test(color);
}

// for empty object checking
// if an object is {}
export function isEmptyObj(obj: any) {
  return Object.keys(obj).length === 0;
}

export function setSingleFeedCookie(value: string) {
    let options: Cookies.CookieAttributes = {
        path: '/',
        expires: 365,
        domain: '.feedspace.io'
    };
    Cookies.set('feedspace-user-id'+(import.meta.env.VITE_APP_MODE != 'production' ? '-test' : ''), value, options);
}

export function removeSingleFeedCookie() {
    let options: Cookies.CookieAttributes = {
        path: '/',
        expires: 365,
        domain: '.feedspace.io'
    };
    Cookies.remove('feedspace-user-id'+(import.meta.env.VITE_APP_MODE != 'production' ? '-test' : ''), options);
}